"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isNull = function (value) {
    return value === null;
};
exports.default = isNull;
//# sourceMappingURL=is-null.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-null.js
// module id = 1122
// module chunks = 37